/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { DataPersistence, fetch, navigation, optimisticUpdate, pessimisticUpdate, NxModule } from './index';

